import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text from 'components/common/Text/Text'
import { Field } from 'redux-form'
import { Input } from 'components/common/FormElements/Input'
import Media from 'components/common/Media'
import Theme from 'src/components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import VehicleEditorButtons from '../VehicleEditorButtons'
import TireEditor from './components/TireEditor'
import EngineEditor from './components/EngineEditor'
import StateEditor from './components/StateEditor'
import Banner from 'components/common/Banner/Banner'
import { integersOnly, addCommas } from './helpers'
import { VEHICLE_DETAILS_INSTRUCTIONS } from '../constants'
import { WRONG_LICENSE_PLATE_OR_STATE_MESSAGE } from 'constant'

const VehicleDetails = ({
  handleSubmit,
  model,
  normalizeValue,
  licencePlateNumber,
  submitFailed,
  error
}) =>
  <Wrapper>
    <Instructions data-at-instructions>{ VEHICLE_DETAILS_INSTRUCTIONS }</Instructions>
    <FormWrapper>
      <Row data-at-editvehiclemodal-nickname>
        <Field
          { ...model.nickname }
          full
          component={ Input } />
      </Row>
      <Row>
        <Field
          { ...model.mileage }
          full
          static
          normalize={ integersOnly }
          format={ addCommas }
          component={ Input } />
      </Row>
      <Row data-at-editvehiclemodal-enginesize>
        <Field { ...model.engine } full component={ EngineEditor } normalize={ normalizeValue } />
      </Row>
      <Row data-at-editvehiclemodal-tiresize>
        <Field { ...model.tires } full component={ TireEditor } normalize={ normalizeValue } />
      </Row>
      <Row>
        <Field
          { ...model.licencePlateNumber }
          full
          static
          component={ Input } />
      </Row>
      { licencePlateNumber &&
        <Row>
          <Field
            { ...model.state }
            full
            optionsMaxHeight={ 200 }
            menuPlacement="top"
            normalize={ normalizeValue }
            component={ StateEditor } />
        </Row>
      }
      {
        submitFailed && error &&
        <CustomBanner error_alternative>
          { WRONG_LICENSE_PLATE_OR_STATE_MESSAGE }
        </CustomBanner>
      }
      <ButtonsWrapper>
        <VehicleEditorButtons handleUpdate={ handleSubmit } />
      </ButtonsWrapper>
    </FormWrapper>
  </Wrapper>

export default VehicleDetails

VehicleDetails.propTypes = {
  error: PropTypes.bool,
  handleSubmit: PropTypes.func,
  licencePlateNumber: PropTypes.string,
  model: PropTypes.shape({
    nickname: PropTypes.shape(),
    licencePlateNumber: PropTypes.shape(),
    engine: PropTypes.shape(),
    mileage: PropTypes.shape(),
    tires: PropTypes.shape(),
    state: PropTypes.shape()
  }),
  normalizeValue: PropTypes.func,
  submitFailed: PropTypes.bool,
  userVehicleDetails: PropTypes.shape({
    masterVehicle: PropTypes.shape(),
    vehicleColor: PropTypes.string
  })
}

const Instructions = styled(Text)`
  color: ${Theme.colors.dark_grey};
  line-height: 22px;
  margin-bottom: 20px;
  display: block;
`

const Wrapper = styled.div`
  padding-top: 20px;
  ${Mixin.responsive('padding-bottom', '41px', '17px')}
`

const FormWrapper = styled.div`
  ${Media.desktop`
    width: 100%;
    margin: 0 auto;
  `}
`

const Row = styled.div`
  margin-bottom: 25px;
`

const ButtonsWrapper = styled.div`
  margin-top: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CustomBanner = styled(Banner)`
  padding-top: 10px;
`
